/**
 * @Author: v_jppjpeng
 * @Date: 2024-08-20 13:23:58
 * @Explain: 组件类
 */

export default {
  // 双因素验证
  'TWO.FACTOR.AUTH.TITLE': '双重身份验证',
  'TWO.FACTOR.AUTH.CODE': '输入2FA验证码',
  'TWO.FACTOR.AUTH.CODE.DESC':
    '打开您的双因素身份验证器应用程序或浏览器扩展程序以查看您的身份验证码。',
  'TWO.FACTOR.AUTH.TIPS1': '遇到问题了？',
  'TWO.FACTOR.AUTH.TIPS2': '使用备份验证码',
  'TWO.FACTOR.AUTH.RECOVERY.TITLE': '备份验证码',
  'TWO.FACTOR.AUTH.ENTER.RECOVERY.CODE': '备份验证码',
  'TWO.FACTOR.AUTH.RECOVERY.TIPS1': '有问题吗？',
  'TWO.FACTOR.AUTH.RECOVERY.TIPS2': '通过smartlink邮箱联系我们',
  'TWO.FACTOR.AUTH.RECOVERY.CODE.PLACEHOLDER': '备份验证码',
  'TWO.FACTOR.AUTH.RECOVERY.CODE.DESC': '输入一个备份验证码以验证您的身份',
  'TWO.FACTOR.AUTH.VERIFY': '验证',
  'TWO.FACTOR.AUTH.RECOVERY.VERIFY.FAIL': '备份验证码验证失败',

  // 编辑提示  v4.8 重组文案
  // 标题
  'COMMON.EDIT.TIP.TITLE': '以下内容应用中，暂时无法操作',
  'COMMON.EDIT.TIP.QUOTE': '应用了',
  'COMMON.EDIT.TIP.QUOTE.THIS': '此',
  'COMMON.EDIT.TIP.QUOTE.AND': '的',
  'COMMON.EDIT.TIP.QUOTE.WHATSAPP': '应用了此联系人字段，模板',
  'COMMON.EDIT.TIP.QUOTE.WHATSAPP.APPROVED': '审批通过',
  'COMMON.EDIT.TIP.QUOTE.WHATSAPP.PENDING': '审批中',
  // 模块
  'COMMON.EDIT.TIP.TYPE.PLACEHOLDER': '占位符',
  'COMMON.EDIT.TIP.TYPE.SEGMENT': '分层规则',
  'COMMON.EDIT.TIP.TYPE.LABEL': '标签',
  'COMMON.EDIT.TIP.TYPE.API': 'API',
  'COMMON.EDIT.TIP.TYPE.FORM': '表单',
  'COMMON.EDIT.TIP.TYPE.SENDER': '发件人',
  'COMMON.EDIT.TIP.TYPE.SENDER.ADDRESS': '发件地址',
  'COMMON.EDIT.TIP.TYPE.SENDER.DOMAIN': '发件域名',
  'COMMON.EDIT.TIP.TYPE.PREFERENCE': '偏好',
  'COMMON.EDIT.TIP.TYPE.USER.JOURNEY': '用户旅程',
  'COMMON.EDIT.TIP.TYPE.TEST.PLAYER.JOURNEY': '测试玩家旅程',
  'COMMON.EDIT.TIP.TYPE.USER.JOURNEY.DIALOG': '用户旅程',
  'COMMON.EDIT.TIP.TYPE.REGULAR.ACTIVITY': '常规活动',
  'COMMON.EDIT.TIP.TYPE.CYCLE.ACTIVITY': '周期活动',
  'COMMON.EDIT.TIP.TYPE.ABTEST.ACTIVITY': 'A/B测试',
  'COMMON.EDIT.TIP.TYPE.MARKET.TEMPLATE': '营销模板',
  'COMMON.EDIT.TIP.TYPE.TRANS.TEMPLATE': '事务模板',
  'COMMON.EDIT.TIP.TYPE.MARKET.DOUBLE.OPT': '二次确认邮件默认设置',
  'COMMON.EDIT.TIP.TYPE.MARKET.CONCAT.ATTRIBUTE': '联系人字段',
  'COMMON.EDIT.TIP.TYPE.MARKET.CONCAT.PREFERENCE': '偏好',
  'COMMON.EDIT.TIP.TYPE.WHATSAPP.TEMPLATE': 'WhatsApp模板',
  // 底部跳转
  'COMMON.EDIT.TIP.BOTTOM.JUMP.DELETE.1': '如需删除请到 ',
  'COMMON.EDIT.TIP.BOTTOM.JUMP.EDIT.1': '如需编辑请到 ',
  'COMMON.EDIT.TIP.BOTTOM.JUMP.2': ' 中解除应用关系。',
  'COMMON.EDIT.TIP.BOTTOM.AND': '、',
  'COMMON.EDIT.TIP.BOTTOM.TARGET.ACTIVITY': '活动',
  'COMMON.EDIT.TIP.BOTTOM.TARGET.USERJOURNEY': '用户旅程',

  // 活动状态
  'COMMON.EDIT.TIP.ACTIVITY.DRAFT': '草稿状态',
  'COMMON.EDIT.TIP.ACTIVITY.PROGRESS': '进行中',
  'COMMON.EDIT.TIP.ACTIVITY.PLAN': '已计划',
  'COMMON.EDIT.TIP.ACTIVITY.TEST': '测试中',
  'COMMON.EDIT.TIP.ACTIVITY.APPROVAL': '审批中',
  'COMMON.EDIT.TIP.ACTIVITY.PAUSE.PASSIVE': '被动暂停',
  'COMMON.EDIT.TIP.ACTIVITY.PAUSE.MANUAL': '手动暂停',
  'COMMON.EDIT.TIP.ACTIVITY.OVER': '已终止',
  'COMMON.EDIT.TIP.ACTIVITY.FINISH': '已完成',
  'COMMON.EDIT.TIP.ACTIVITY.SEND.STOP': '发送中断',
  // 旅程状态
  'COMMON.EDIT.TIP.USERJOURNEY.DRAFT': '草稿状态',
  'COMMON.EDIT.TIP.USERJOURNEY.ACTIVE': '激活中',
  'COMMON.EDIT.TIP.USERJOURNEY.ABNORMAL': '节点异常',
  'COMMON.EDIT.TIP.USERJOURNEY.PAUSE': '暂停中',
  'COMMON.EDIT.TIP.USERJOURNEY.END': '已结束',
  // 表单状态
  'COMMON.EDIT.TIP.FORM.ACTIVE': '激活中',
  'COMMON.EDIT.TIP.FORM.UNACTIVE': '未激活',
  // API状态
  'COMMON.EDIT.TIP.API.ACTIVE': '启用中',
  'COMMON.EDIT.TIP.API.REVOKE': '被撤销',
};
